import React, {useEffect, useState} from "react"
import {AiOutlineClose} from "react-icons/ai";
import "./points.scss"
import {DropDownCheck, FireIcon, SFilterIcon} from "../../../../../assets/icons/defaultIcons";
import {StreakService} from "../../../../services/streak-api.service";
import {Dropdown} from "antd";
import dayjs from "dayjs";
import StreakListSkeleton from "../../../skeletons/home/points/StreakListSkeleton";
import NoRecord from "../../../../components/dashboard/no-record/NoRecord";

export default function StreakList({close}) {
    const [streakData, setStreakData] = useState([])
    const [selectedItem, setSelectedItem] = useState('All');
    const [loader , setLoader] = useState(false)

    async function GetStreakData(filterType=40,selected='All') {
        setSelectedItem(selected)
        let endDate = dayjs().format('YYYY-MM-DD');
        let startDate = ''

        switch (filterType) {
            case 10:

                startDate = dayjs().subtract(1, 'week').format('YYYY-MM-DD');
                break
            case 20:

                startDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD');
                break
            case 30:

                startDate = dayjs().subtract(3, 'month').format('YYYY-MM-DD');
                break
            default:
                endDate = '';
                startDate = '';
                break
        }

        setLoader(true)
        const response = await StreakService.getStreakData(startDate,endDate);
        if(response?.data?.status){
            setStreakData(response.data?.data?.data)
            setLoader(false)
        }
    }

    useEffect(()=>{
        GetStreakData()
    },[])

    if (loader){
        return <StreakListSkeleton/>
    }

    const items = [
        {
            key: '1',
            label: (
                <a onClick={()=>{GetStreakData(40, 'All')}} className={'d-flex justify-content-between w-100'}>
                    All {selectedItem === 'All' &&  <span><DropDownCheck/></span> }
                </a>
            ),
        },
        {
            key: '2',
            label: (
                <a onClick={()=>{GetStreakData(10, 'Weekly')}} className={'d-flex justify-content-between w-100'}>
                    Weekly {selectedItem === 'Weekly' &&  <span><DropDownCheck/></span> }
                </a>
            ),
        },
        {
            key: '3',
            label: (
                <a onClick={()=>{GetStreakData(20, 'Monthly')}} className={'d-flex justify-content-between w-100'}>
                    Monthly {selectedItem === 'Monthly' &&  <span><DropDownCheck/></span> }
                </a>
            ),
        },
        {
            key: '4',
            label: (
                <a onClick={()=>{GetStreakData(30, 'Quaterly')}} className={'d-flex justify-content-between w-100'}>
                    Quaterly {selectedItem === 'Quaterly' &&  <span><DropDownCheck/></span> }
                </a>
            ),
        },
    ];

    return(
        <div className={'points-list'}>
            <div className={'points-list-header'}>
                <h3>
                    <span className={'heading-streak-modal'}>   <i>Streaks</i>
                        <Dropdown menu={{ items }} placement="bottomLeft" trigger={'click'} loading={loader}>
                            <span className={'theme-dropdown-1'}><SFilterIcon/>  {selectedItem ? selectedItem : ''}</span>
                        </Dropdown>
                    </span>
                    <span className={'close-btn'} onClick={()=>{close(false)}}><AiOutlineClose /> </span>
                </h3>
            </div>
            <div className={'filter-sec'}>

            </div>
            <div className={'points-list-details'}>
                {
                    streakData.length > 0 ?
                        <ul>
                            {
                                streakData.map((item,index)=>{
                                    return(
                                        <li key={index}>
                                            <p>You've met Point Streak <span>+1 <FireIcon/></span></p>
                                        </li>
                                    )
                                })
                            }

                        </ul>
                        :
                        <NoRecord/>
                }


            </div>
        </div>
    )
}